/**
 * Per-country-locale availability map keyed by `${country}-${locale}`.
 * Missing entries default to "available" (true). Explicit `false` hides
 * the item from the named market. Used on tests, products, FAQ entries.
 *
 * Example: `{ "de-de": false }` hides the item from /de/de/ but leaves
 * every other market unaffected.
 */
export type Availability = Partial<Record<string, boolean>>

export function isAvailable(
  availability: Availability | undefined,
  country: string,
  locale: string
): boolean {
  if (!availability) return true
  const key = `${country}-${locale}`
  return availability[key] !== false
}
